import { Card } from "@/components/ui/card";
import { useCurrentClient } from "@/features/clients/hooks/use-clients";
import { ExternalAccountsAPI } from "@/features/external-accounts/api/external-accounts";
import type { ExternalAccountSettings } from "@/features/external-accounts/types";
import { useTranslation } from "@/features/utils/i18n";
import { useEffect, useState } from "react";

export const SyncSummaryCard = () => {
  const { t } = useTranslation("externalAccounts");
  const client = useCurrentClient();
  const clientId = client?.client?.id;
  const [settings, setSettings] = useState<ExternalAccountSettings | null>(
    null,
  );

  useEffect(() => {
    const loadSettings = async () => {
      if (!clientId) return;

      try {
        const data = await ExternalAccountsAPI.getSettings(clientId);
        setSettings(data);
      } catch (error) {
        console.error("Error loading settings:", error);
      }
    };

    loadSettings();
  }, [clientId]);

  if (!settings) {
    return (
      <Card>
        <p>{t("externalAccounts.syncSummary.notConfigured")}</p>
      </Card>
    );
  }

  return (
    <Card>
      <div className="space-y-2 p-2">
        <div>
          <strong>{t("externalAccounts.syncSummary.calendarSync")}</strong>{" "}
          {settings.primary_calendar_name ||
            t("externalAccounts.syncSummary.none")}
        </div>
        <div>
          <strong>{t("externalAccounts.syncSummary.contactsSync")}</strong>{" "}
          {settings.contacts_addressbook_name ||
            t("externalAccounts.syncSummary.none")}
        </div>
      </div>
    </Card>
  );
};
